import {
  dimensionSpiritualityIcon,
  dimensionDemocracyIcon,
  dimensionEnvironmentIcon,
  dimensionHealthIcon,
  dimensionFitnessIcon,
  dimensionStudentWelfareIcon,
  dimensionEducationIcon,
  dimensionSpiritualityHero,
  dimensionDemocracyHero,
  dimensionEnvironmentHero,
  dimensionHealthHero,
  dimensionFitnessHero,
  dimensionStudentWelfareHero,
  dimensionEducationHero,
} from '../assets/index'

export const DESIGN_WIDTH = 1920
export const DESIGN_HEIGHT = 1080

export const DIMENSION_CARD_WIDTH = 400
export const DIMENSION_CARD_HEIGHT = 420
/** pt 20 + header row 52 + gap 20 */
export const DIMENSION_CARD_IMAGE_TOP = 92
export const DIMENSION_CARD_IMAGE_HEIGHT = DIMENSION_CARD_HEIGHT - DIMENSION_CARD_IMAGE_TOP
export const STUDENT_WELFARE_CARD_INDEX = 5

export const dimensions = [
  {
    title: 'Spirituality',
    description:
      'Nurturing inner growth, moral values, and cultural consciousness among youth.',
    image: dimensionSpiritualityHero,
    icon: dimensionSpiritualityIcon,
    iconBgColor: 'rgba(7,30,183,0.2)',
    path: '/dimensions/spirituality',
    left: 66,
    top: 220,
    rotate: 0,
    zIndex: 3,
    entryX: -360,
    entryY: 0,
    entryRotate: -14,
  },
  {
    title: 'Democracy',
    description: 'Encouraging civic responsibility and nation-building participation.',
    image: dimensionDemocracyHero,
    icon: dimensionDemocracyIcon,
    iconBgColor: 'rgba(7,183,183,0.2)',
    path: '/dimensions/democracy',
    left: 357,
    top: -145,
    rotate: 34.16,
    zIndex: 4,
    rotateOrigin: true,
    entryX: 0,
    entryY: -340,
    entryRotate: 10,
  },
  {
    title: 'Environment',
    description:
      'Encouraging environmental awareness and sustainable practices for a better future.',
    image: dimensionEnvironmentHero,
    icon: dimensionEnvironmentIcon,
    iconBgColor: 'rgba(183,7,7,0.2)',
    path: '/dimensions/environment',
    left: 1038,
    top: -82,
    rotate: -19.66,
    zIndex: 5,
    rotateOrigin: true,
    entryX: 200,
    entryY: -320,
    entryRotate: -8,
  },
  {
    title: 'Health',
    description: 'Promoting physical, mental, and social well-being for a healthier society.',
    image: dimensionHealthHero,
    icon: dimensionHealthIcon,
    iconBgColor: 'rgba(183,142,7,0.2)',
    path: '/dimensions/health',
    left: 1439,
    top: 183,
    rotate: 0,
    zIndex: 6,
    imageHeight: 320,
    imageObjectPosition: 'center',
    imageScale: { width: '111%', height: '185%', left: '-4.62%', top: '-1.11%' },
    entryX: 380,
    entryY: 0,
    entryRotate: 12,
  },
  {
    title: 'Fitness',
    description: 'Building confidence and discipline through fitness and active living.',
    image: dimensionFitnessHero,
    icon: dimensionFitnessIcon,
    iconBgColor: 'rgba(183,7,171,0.2)',
    path: '/dimensions/fitness',
    left: 168,
    top: 610,
    rotate: 20.06,
    zIndex: 3,
    rotateOrigin: true,
    entryX: -300,
    entryY: 320,
    entryRotate: -10,
  },
  {
    title: 'Student Welfare',
    description: 'Supporting students through guidance, mentorship, and growth.',
    image: dimensionStudentWelfareHero,
    icon: dimensionStudentWelfareIcon,
    iconBgColor: 'rgba(8,39,83,0.2)',
    path: '/dimensions/student-welfare',
    left: 826,
    top: 666,
    rotate: 0,
    zIndex: 7,
    entryX: 0,
    entryY: 360,
    entryRotate: 8,
  },
  {
    title: 'Education',
    description: 'Empowering youth through education, leadership, and values.',
    image: dimensionEducationHero,
    icon: dimensionEducationIcon,
    iconBgColor: 'rgba(183,7,7,0.2)',
    path: '/dimensions/education',
    left: 1412,
    top: 629,
    rotate: -7.94,
    zIndex: 4,
    rotateOrigin: true,
    educationLayout: true,
    imageScale: { width: '100%', height: '166.67%', left: 0, top: '-33.33%' },
    entryX: 340,
    entryY: 280,
    entryRotate: -12,
  },
]
